var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30642 7.11921C6.83787 7.58657 6.07694 7.58657 5.60838 7.11921L0.810382 2.33345C0.465526 1.98947 0.364318 1.47725 0.55174 1.02858C0.739162 0.579916 1.17398 0.288283 1.66128 0.288283H11.2573C11.7408 0.288283 12.1794 0.579916 12.3668 1.02858C12.5542 1.47725 12.4493 1.98947 12.1082 2.33345L7.31017 7.11921H7.30642Z",
    fill: "#BF2114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownAero);
export default __webpack_public_path__ + "static/media/downAero.01bcb3289991eedf83b5008d20261042.svg";
export { ForwardRef as ReactComponent };